import Colors from './utils/colors';
import { important } from './utils';

const Styles = {
  containerNavbar: important({
    height: '72px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    boxShadow: '0px 8px 16px 0px rgba(26, 65, 107, 0.15)',
  }),
  containerLight: important({
    background: Colors.white,
    color: Colors.secondary,
  }),
  containerDark: important({
    background: Colors.secondary,
    color: Colors.white,
  }),
  containerContent: important({
    padding: '0',
  }),
  containerPadding: important({
    padding: '0 40px',
    width: '100%',
    '@media (max-width:600px)': {
      padding: '0 24px',
    },
    '@media (min-width:1536px)': {
      maxWidth: '1536px',
      margin: '0 auto',
      padding: '0 20px',
    },
  }),
  containerPaddingApp: important({
    padding: '0 92px',
    width: '100%',
    '@media (max-width:780px)': {
      padding: '0 24px',
    },
  }),
};

export default Styles;
